import React from 'react';
import './App.scss';
import RouteComponents from "./routing/RouteComponents";

function App() {
  return (
      <div className='container-fluid h-100 p-0'>
        <RouteComponents />
      </div>
  );
}

export default App;
